import { createApp } from 'vue'
import App from './App.vue'
import '@/global.css'
import { ElCarousel, ElCarouselItem } from 'element-plus'
import 'element-plus/dist/index.css'
const app = createApp(App)
app.use(ElCarousel, ElCarouselItem)
app.mount('#app')